export default __webpack_public_path__ + "static/media/d2d.8f70c182.jpg";